<template>
	<ui-modal-template>
		<template v-slot:title>
			<span>cropspot+ Kündigung widerrufen</span>
		</template>
		<template v-slot:content>
			<div class="px-6 py-6">
				<div class="px-6">
					<p>Möchten Sie Ihre cropspot+ Kündigung wirklich widerufen?</p>
				</div>
			</div>
			<div class="bg-gray-100 p-6">
				<div class="flex justify-end px-6">
					<ui-button
						v-on:click="submitForm()"
						label="Kündigung widerufen"
					/>
				</div>
			</div>
		</template>
		<!-- devide -->
	</ui-modal-template>
</template>
<script>
import axios from "axios";
import toast from '../../services/toast';

// todo disable button while executing
export default {
	props: {
		id: {
			type: Number,
			default: null
		}
	},
	methods: {
		async submitForm() {

			const params = {};
			params["id"] = this.id;

			let promise = new Promise((resolve, reject) => {
				const response = axios.post(this.$route("premium.terminate.revoke", params));

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			this.$bus.$emit("modal:close");
			this.$bus.$emit("page:content:load");

			this.$toast.success('Der Widerruf ihrer Kündigung war erfolgreich!');
		},
		onError(error) {
			const errors = error.response.data.errors;
			this.$bus.$emit("form:invalid", errors);
		},
	},
};
</script>
